import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Divider, Skeleton } from '@mui/material';
import { getDigitalChannelAffinity } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';
import { actions } from '../../../../redux/reducers/physicianTargetListAnalysisReducer';
import { BarChart, CustomButtonGroup } from '../../../shared';
import { PREFERENCES, DIGITAL_CHANNEL_AFFINITY_OPTIONS, } from './constants';

function DigitalChannelAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { setDigitalChannelPreference } = actions;
    const { company } = useSelector(state => state.company);
    const { digitalChannel } = useSelector(state => state.physicianTargetListAnalysis);
    const { selectedPreference, data, chartSeries, categories, isLoading } = digitalChannel;

    useEffect(() => {
        if(company.id){
            dispatch(getDigitalChannelAffinity({companyId: company.id}));
        }
    }, [company.id]);

    return (
        <Box className="box-sizing-border-box br-16px border-1-gray">
            <Box className="flex-column gap-4 padding-24px border-bottom-gray">
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className="text-md-semi-bold gray-900">
                            Digital Channel Affinity
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    {isLoading ? <Skeleton height={45} /> :<CustomButtonGroup
                        data={PREFERENCES}
                        selected={selectedPreference}
                        handleClick={(option) => dispatch(setDigitalChannelPreference({preference: option}))}
                    />}
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box className="padding-24px height-343px apexchart-horizontal-bar-chart">
                        {isLoading ? <Skeleton height={340} /> : <BarChart
                            chartOptions={
                                {
                                    ...DIGITAL_CHANNEL_AFFINITY_OPTIONS,
                                    xaxis: {
                                        ...DIGITAL_CHANNEL_AFFINITY_OPTIONS.xaxis,
                                        categories: categories,
                                    }
                                }
                            }
                            chartSeries={chartSeries}
                        />}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default DigitalChannelAffinity;
